import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Spin } from "antd";
import { toast } from "react-toastify";
import { tiposContratosApi } from "../../services/api";

const TipoContratoFormModal = ({ visible, onCancel, onSuccess, editingTipoContrato }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isEditing = !!editingTipoContrato;

  useEffect(() => {
    if (visible && isEditing) {
      // Completar formulario con datos existentes si estamos editando
      form.setFieldsValue({
        tipo_contrato: editingTipoContrato.tipo_contrato,
      });
    } else if (visible) {
      // Limpiar formulario si estamos creando
      form.resetFields();
    }
  }, [visible, editingTipoContrato, form, isEditing]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (isEditing) {
        // Actualizar tipo de contrato existente
        await tiposContratosApi.update(editingTipoContrato.id, values);
        toast.success("Tipo de contrato actualizado correctamente", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        // Crear nuevo tipo de contrato
        await tiposContratosApi.create(values);
        toast.success("Tipo de contrato creado correctamente", {
          position: "top-right",
          autoClose: 4000,
        });
      }

      setLoading(false);
      onSuccess();
    } catch (error) {
      console.error("Error al guardar tipo de contrato:", error);
      let errorMsg = "Error al guardar los datos";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMsg = error.response.data.message;
      }
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 4000,
      });
      setLoading(false);
    }
  };

  return (
    <Modal
      title={isEditing ? "Editar Tipo de Contrato" : "Nuevo Tipo de Contrato"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      maskClosable={false}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="mt-4"
        >
          <Form.Item
            label="Nombre del Tipo de Contrato"
            name="tipo_contrato"
            rules={[
              {
                required: true,
                message: "Por favor ingrese el nombre del tipo de contrato",
              },
            ]}
          >
            <Input placeholder="Ej: Tiempo Completo" />
          </Form.Item>

          <div className="flex justify-end gap-2 mt-6">
            <Button onClick={onCancel}>Cancelar</Button>
            <Button
              type="primary"
              htmlType="submit"
              className="bg-blue-600 hover:bg-blue-700"
            >
              {isEditing ? "Actualizar" : "Crear"}
            </Button>
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

export default TipoContratoFormModal;